export const DASHBOARD_EMAIL_ALLOWLIST = [
  "babita.n@trezi.com",
  "sudarshan@smartvizx.com",
];
